import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';
import { UserInDto } from 'shared/domain/user/types/inDto';
import {
  isUserUploadErrorResponse,
  resolveEditedUserFromEditResponse,
  toSingleUserInDto,
} from 'shared/domain/user/mapping/userEditResponse';
import { broadcastUploadedUserError } from 'serviceWorker/broadcasts/user/error';
import {
  broadcastUploadedUser,
  broadcastUpdatedUser,
  broadcastDeletedUser,
} from 'serviceWorker/broadcasts/user/one';
import { chooseErrorMessage } from 'shared/utils/errorHandling';
import { neverReached } from 'shared/utils/neverReached';

export function broadcastUserResponse(
  request: HttpRequestEntity,
  response: UserInDto | UserInDto[] | { error: unknown }
): void {
  const { uniqueId } = request.data;
  if (isUserUploadErrorResponse(response)) {
    return broadcastUploadedUserError(
      response.error,
      chooseErrorMessage(response.error),
      uniqueId
    );
  }

  switch (request.method) {
    case 'POST':
    case 'GET':
      broadcastUploadedUser(toSingleUserInDto(response), uniqueId);
      return;
    case 'PUT':
      broadcastUpdatedUser(
        resolveEditedUserFromEditResponse(request.url, response),
        uniqueId
      );
      return;
    case 'DELETE':
      broadcastDeletedUser(response, uniqueId);
      return;
    default:
      neverReached(request.method);
  }
}

/** Carries the change's `uniqueId`, so the page's command rejects with this error. */
export function broadcastUserError(
  request: HttpRequestEntity,
  error: unknown,
  uniqueId?: string
): void {
  broadcastUploadedUserError(
    error,
    chooseErrorMessage(error),
    uniqueId ?? request.data?.uniqueId
  );
}
